import React from "react";

import IconUnknow from "~/components/Icons/mimeType/icon-unknow-file";
import DocxIcon from "~/components/Icons/svg/docx";
import ExcelIcon from "~/components/Icons/svg/excel";
import PdfIcon from "~/components/Icons/svg/pdf";

import s from "./DocumentsSections.less";

const GetIcon = ({ filename }: { filename?: string }) => {
  if (!filename) {
    return <IconUnknow />;
  }
  if (filename.includes(".docx") || filename.includes(".doc")) {
    return (
      // <Tooltip text={filename} customClassName={s.custom_style_tooltip}>
      <div className={s.wrapper_icon}>
        <DocxIcon />
        <div>{filename}</div>
      </div>
      // </Tooltip>
    );
  }
  if (filename.includes(".pdf")) {
    return (
      // <Tooltip text={filename} customClassName={s.custom_style_tooltip}>
      <div className={s.wrapper_icon}>
        <PdfIcon />
        <div>{filename}</div>
      </div>
      // </Tooltip>
    );
  }

  const excelExtensions = [
    ".xlsx",
    ".xls",
    ".xlsm",
    ".xlsb",
    ".xltx",
    ".xltm",
    ".csv",
  ];

  if (excelExtensions.some((ext) => filename.toLowerCase().endsWith(ext))) {
    return (
      // <Tooltip text={filename} customClassName={s.custom_style_tooltip}>
      <div className={s.wrapper_icon}>
        <ExcelIcon />
        <div>{filename}</div>
      </div>
      // </Tooltip>
    );
  }
  return <IconUnknow />;
};

export default GetIcon;
